import { Box, Skeleton, Typography } from "@mui/material";
import { WidgetHeader } from "components/atoms/WidgetHeader";
import { WidgetPaper } from "components/atoms/WidgetPaper";
import { ReactElement } from "react";

interface Props {
  header: string | ReactElement;
  description?: string | ReactElement;
  value: number | string;
  actionCardChildren?: ReactElement;
  postfix?: ReactElement | string;
  loading?: boolean;
}

export const NumberChart = ({
  header,
  description,
  value,
  actionCardChildren,
  postfix,
  loading,
}: Props) => {
  return (
    <WidgetPaper
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flexGrow: 1,
        }}
      >
        <WidgetHeader label={header} description={description} />
        <Box
          sx={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "flex-end",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={(theme) => ({
              fontSize: "72px",
              lineHeight: "72px",
              fontWeight: 700,
              fontFamily: theme.typography.fontFamily,
            })}
          >
            {loading ? (
              <Skeleton
                variant="rounded"
                width={100}
                height={20}
                sx={{ margin: "26px 0" }}
              />
            ) : (
              value
            )}
          </Typography>
          {postfix ? (
            <Typography
              sx={(theme) => ({ fontSize: 24, color: theme.palette.grey[400] })}
            >
              {postfix}
            </Typography>
          ) : null}
        </Box>
      </Box>
      {actionCardChildren}
    </WidgetPaper>
  );
};
